export default __webpack_public_path__ + "static/media/el_4.0d15a92e.mp3";